import { Link } from "gatsby";
import React from "react";
import { twMerge } from "tailwind-merge";

interface SecondaryButtonProps {
  children: React.ReactNode;
  internalPath?: string;
  externalUrl?: string;
  new_window?: "_blank" | "_self" | string;
  className?: string;
  variant?: SecondaryButtonVariant;
  onClick?: () => void;
  disabled?: boolean;
}

export type SecondaryButtonVariant =
  | "cream_fill"
  | "light_blue_outline"
  | "light_pink_fill";

const SecondaryButton = ({
  new_window = "_self",
  variant = "cream_fill",
  className,
  onClick,
  disabled,
  ...props
}: SecondaryButtonProps) => {
  let variants;
  switch (variant) {
    case "cream_fill":
      variants =
        "bg-cream text-navy hover:bg-navy hover:text-cream hover:border-cream";
      break;
    case "light_blue_outline":
      variants =
        "bg-transparent text-lightBlue border-lightBlue hover:bg-lightBlue hover:text-navy";
    case "light_pink_fill":
      variants =
        "bg-lightPink text-redWood hover:text-lightPink hover:bg-redWood shadow-[2px_2px_4px]";
  }

  const Component =
    props.internalPath != "" && props.internalPath != undefined ? Link : "a";

  const disabledStyles = disabled ? "opacity-50 cursor-not-allowed" : "";

  return (
    <Component
      to={props.internalPath as string}
      href={props.externalUrl}
      target={new_window}
      onClick={disabled ? undefined : onClick} // Prevent onClick function when disabled
      className={twMerge(
        "flex h-[50px] cursor-pointer items-center justify-center rounded-full border-2 border-transparent px-6 font-heading text-2xl tracking-[1.44px] transition-colors",
        variants,
        className,
        disabledStyles
      )}
    >
      {props.children}
    </Component>
  );
};

export default SecondaryButton;

// Type for data from Kontent.ai
export type KontentSecondaryButton = {
  system: { type: string };
  elements: {
    text: { value: string };
    internal_path: { value: string };
    external_url: { value: string };
    new_window: { value: [{ codename: string }] };
    variant: { value: [{ codename: SecondaryButtonVariant }] };
  };
};
